/**
 * this component should take responsibility for displaying either errors toasts for backend responses or the success toasts.
 */

import ToastContent from '@trackman/web-shared-components/components/Toast/ToastContent';
import { observer } from 'mobx-react-lite';
import { singleNotificationType } from 'stores/NotificationsStore';
import { t } from 'utilities/TranslationUtils';
import { useStores } from 'index';

const AppNotificationsToast = observer(() => {
  const { allNotifications, clearNotification } = useStores().notificationStore;

  const getSystemUpdateToastHeader = (singleNotification: singleNotificationType) => {
    if (singleNotification.title) return singleNotification.title;
    return singleNotification.variant === 'error' ? singleNotification.errorBag?.title : t('common.success');
  };

  const getSystemUpdateToastBody = (singleNotification: singleNotificationType) => {
    if (singleNotification.message) return singleNotification.message;
    if (singleNotification.variant === 'error') return singleNotification.errorBag?.message || t('toastMessages.failed_unknown_reason');

    if (!singleNotification.purpose) return '';

    return t(`toast.${singleNotification.purpose}`);
  };

  return (
    <div
      style={{
        top: '24px',
        right: '24px',
        zIndex: '1400',
        position: 'fixed',
        alignItems: 'center',
        justifyContent: 'flex-end',
      }}
    >
      <>
        {allNotifications.map((singleNotification, index) => (
          <div className={`app_response_toast mb-4 app_response_toast--${singleNotification.variant}`} key={index}>
            <ToastContent
              key={singleNotification.id}
              id={singleNotification.id}
              onClose={() => clearNotification(singleNotification.id)}
              severity={singleNotification.variant}
              header={getSystemUpdateToastHeader(singleNotification)}
              message={getSystemUpdateToastBody(singleNotification)}
            />
          </div>
        ))}
      </>
    </div>
  );
});

export default AppNotificationsToast;
